import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from "@angular/core";
import { SnotifyService } from "ng-snotify";
import { Config } from "../../config/config";
import { RestDataService } from "../../service/rest-data.service";
import { SharedDataService } from "../../service/shared-data.service";
import { StaticDataService } from "../../service/static-data.service";
import { isEqual } from 'lodash';
import { cloneDeep } from 'lodash';
import { DragulaService } from 'ng2-dragula';
import * as dragula from 'dragula';
import { ActivatedRoute } from "@angular/router";
import Editor from "../../../assets/js/ckeditor";
import { ChangeEvent } from "@ckeditor/ckeditor5-angular";

@Component({
  selector: 'photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss']
})

export class PhotoGalleryComponent implements OnInit, OnChanges {

  @Input() EditMode: boolean;
  @Input() elements: any;
  @Input() viewPortItems: any[];
  @Input() storytype: any;
  @Input() storyId: any;
  @Input() leadMediaId: string;
  @Input() showToggle: boolean;
  @Input() storyData: any;
  @Output() deleteCardfn = new EventEmitter<any>();
  @Output() emitParentImageIdDelete = new EventEmitter<any>();
  @Output() setAsLeadMediafn = new EventEmitter<any>();
  @Output() ampValidationOutput = new EventEmitter<any>();
  @Output() cropCompletedEvent = new EventEmitter<string>();
  @Output() updateCardDatafn = new EventEmitter<any>();
  @Output() updateContentOnParent = new EventEmitter<any>();
  @Output() sendWordCountToStory = new EventEmitter<any>();
  @Output() emitParentImageId = new EventEmitter<any>();
  editCardFlag = new Map<any, boolean>();
  loaded = new Map<any, boolean>();
  tempElements = new Map<any, any>();
  isLocked = new Map<any, boolean>();
  domainConfig: any;
  captionRestrictionEnabled = false;
  isMultipleLeadImageAllowed: boolean = false;
  isCKEditorEnabled = false;
  cropAllGallery: boolean;
  hideDragger: false;
  showRelatedStoryPopup: boolean = false;
  cropForLeadMedia = false;
  showCropper = false;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  amazonAds=[];
  cardData: any;
  //id: any;
  id: any[] = [];
  enableRelatedStoryInlineImage: any;
  relatedStoryType: string = 'gallery';
  relatedStoryTempList = [];
  relatedStoryMultipleSelectFlag: boolean = false;
  captionEditor: any;
  outerDivFocus = false;
  page_id = StaticDataService.element_page_id;
  save_api = StaticDataService.element_save_api;
  get_api = StaticDataService.element_get_api;
  lockAcquire_api = StaticDataService.story_lockAcquire_api;
  lockRelease_api = StaticDataService.story_lockRelease_api;
  public ckEditor = Editor;
  enableAmazonMeta:boolean;
  ckconfig = {
    toolbar: ['numberedList', 'bulletedList', 'link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    }
  };

  constructor(private sharedService: SharedDataService,
    public config: Config,
    private http: HttpClient,
    private snotify: SnotifyService,
    public restService: RestDataService,
    private dragulaService: DragulaService,
    private route: ActivatedRoute,
    private renderer: Renderer2) {
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.isCKEditorEnabled = this.sharedService.isdomainConfig('story', 'vernacular-editor');
    this.captionRestrictionEnabled = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['imageRestriction']
      && this.domainConfig['config']['story']['imageRestriction'] !== '');
    this.enableAmazonMeta = this.domainConfig['config']['story']['enableAmazonMeta'];
    this.isMultipleLeadImageAllowed = this.sharedService.isdomainConfig('image', 'multipleLeadImage');
    this.enableRelatedStoryInlineImage = this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableRelatedStoryInlineImage'] == undefined ? [] : this.domainConfig['config']['story']['enableRelatedStoryInlineImage'];
    //this.enableRelatedStoryInlineImage = ["gallery"];
    dragulaService.setOptions('gallery-bag', {
      moves: function (el, container, handle) {
        return (handle.className === 'handle sortpara' || handle.className === 'icon-move');
      }
    });
    dragulaService.dropModel.subscribe((value) => {
      console.log(this.storyData);
      console.log(this.viewPortItems);
      this.storyData.elements = cloneDeep(this.viewPortItems);
    });
  }

  ngOnInit(): void {
  //   this.route.queryParams.subscribe(params => {
  //     if(params.refId && this.elements && !this.elements[this.viewPortItems[0]]){
  //       this.viewPortItems = JSON.parse(localStorage.getItem('viewPortId'));
  //       this.elements = JSON.parse(localStorage.getItem('elements'));
  //     }
  // });
    if (this.elements && this.viewPortItems) {
      const regex = new RegExp('www.livemint.com', 'g');
      for (let i = 0; i < this.viewPortItems.length; i++) {
        this.editCardFlag.set(this.viewPortItems[i], false);
        this.loaded.set(this.viewPortItems[i], false);
        this.tempElements.set(this.viewPortItems[i], cloneDeep(this.elements[this.viewPortItems[i]]));
        this.isLocked.set(this.viewPortItems[i], false);
        let data =  this.tempElements.get(this.viewPortItems[i]);
        if (data.hasOwnProperty('parentElementId')) {
          if (data['parentElementId'] === 0) {
            this.emitParentImageId.emit(data['id']);
          } else {
            this.emitParentImageId.emit(data['parentElementId']);
          }
        } else {
          this.emitParentImageId.emit(data['id']);
        }
        // for (const key of Object.keys(data.image.images)) {
        //   if (data[key] && (data.image.images[key].indexOf('www.livemint.com') > -1)) {
        //     data.image.images[key] = data.image.images[key].replace(regex, 'images.livemint.com');
        //   }
        // }
      }
    }
    const drake = dragula();
    let bag: any = this.dragulaService.find('gallery-bag');
    if (bag === undefined) {
      this.dragulaService.add('gallery-bag', drake);
      bag = this.dragulaService.find('gallery-bag');
    }
  }

  setThisAmazonMeta(elementId,event) {
    this.tempElements.get(elementId).amazonMeta = event.target.checked;
    this.tempElements.get(elementId).amazonAds[0].key ='';
    this.tempElements.get(elementId).amazonAds[0].value = '';
    this.tempElements.get(elementId).amazonAds[0].isPresent = false;
    this.tempElements.get(elementId).amazonCheckedItem = false;
    this.tempElements.get(elementId).amazonTitle = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.elements && changes.elements.previousValue) {
      const previousKeys = Object.keys(changes.elements.previousValue);
      const currentKeys = Object.keys(changes.elements.currentValue);
      if (currentKeys.length > previousKeys.length) {
        const regex = new RegExp('www.livemint.com', 'g');
        const diff = this.getDifference(currentKeys, previousKeys);
        for (let i = 0; i < diff.length; i++) {
          if (this.viewPortItems && this.viewPortItems.length > 0 && this.viewPortItems.indexOf(+diff[i]) > -1 && !this.tempElements.has(+diff[i])) {
            this.editCardFlag.set(+diff[i], false);
            this.loaded.set(+diff[i], false);
            this.tempElements.set(+diff[i], cloneDeep(changes.elements.currentValue[diff[i]]));
            this.isLocked.set(+diff[i], false);
            let data = this.tempElements.get(+diff[i]);
            if (data.hasOwnProperty('parentElementId')) {
              if (data['parentElementId'] === 0) {
                this.emitParentImageId.emit(data['id']);
              } else {
                this.emitParentImageId.emit(data['parentElementId']);
              }
            } else {
              this.emitParentImageId.emit(data['id']);
            }
            // for (const key of Object.keys(data.image.images)) {
            //   if (data[key] && (data.image.images[key].indexOf('www.livemint.com') > -1)) {
            //     data.image.images[key] = data.image.images[key].replace(regex, 'images.livemint.com');
            //   }
            // }
            this.onelementFocus(+diff[i]);
            this.loaded.set(+diff[i], true);
          }
        }
      } else if (currentKeys.length < previousKeys.length) {
        const diff = this.getDifference(previousKeys, currentKeys);
        for (let i = 0; i < diff.length; i++) {
          if (this.viewPortItems && this.viewPortItems.length > 0 && this.viewPortItems.indexOf(+diff[i]) < 0 && this.tempElements.get(+diff[i])) {
            this.editCardFlag.delete(+diff[i]);
            this.loaded.delete(+diff[i]);
            this.tempElements.delete(+diff[i]);
            this.isLocked.delete(+diff[i]);
          } else if (this.viewPortItems == null || this.viewPortItems == undefined || this.viewPortItems.length == 0) {
            this.editCardFlag = new Map<any, boolean>();
            this.loaded = new Map<any, boolean>();
            this.tempElements = new Map<any, any>();
            this.isLocked = new Map<any, boolean>();
          }
        }
      }
    } else if (changes.viewPortItems && changes.viewPortItems.previousValue && (changes.viewPortItems.previousValue.length == changes.viewPortItems.currentValue.length)) {
      console.log("order changeed");
    }
  }

  ngOnDestroy()
  {
    if (this.dragulaService.find('gallery-bag')) {
      this.dragulaService.destroy('gallery-bag');
    }
    this.editCardFlag = null;
    this.loaded = null;
    this.tempElements = null;
    this.isLocked = null;
    this.snotify.clear();
    this.sharedService.overflowauto();
  }

  getDifference(a: any[], b: any[]) {
    return a.filter((element) => {
      return !b.includes(element);
    });
  }

  // trackByFn(index: any, item: any) {
  //   return index;
  // }

  serveElement(elementId) {
    return this.tempElements.get(elementId);
  }

  serveLoaded(elementId) {
    return this.loaded.get(elementId);
  }

  serveEdit(elementId) {
    return this.editCardFlag.get(elementId);
  }

  imgLoaded(load, index) {
    this.loaded.set(index, true);
  }

  ifCroppedDomain(elementId) {
    this.cropAllGallery = this.sharedService.isdomainConfig('image', 'cropAll');
    if (this.cropAllGallery === true && this.storytype === 'gallery') {
      if (this.tempElements.get(elementId)['image']['images']['1600x900']) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  onelementFocus(elementId) {
    let cardData = this.tempElements.get(elementId);
    this.editCardFlag.set(elementId, true);
    if (cardData && cardData.id && this.EditMode && cardData.reusable) {
      this.lockAcquire(cardData.id, flag => {
      });
    }
  }

  startCropping(elementId) {
    let cardData = this.tempElements.get(elementId);
    if (cardData) {
      const elementImageURL = this.sharedService.getImageOnPriority(cardData['image']['images'], 'original');
      if (elementImageURL.indexOf('popper.ai/') === -1) {
        const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
        this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
          if (data !== false) {
            
            if(this.id == null || this.id.length == 0)
            {
              this.id = [];
            }
            //this.id = elementId;
            this.id.push(elementId);
            this.storyData.type==='infographic' ? this.showCropper = false : this.showCropper = true;
            this.openCropper(false, data);
          } else {
            this.cancelCropping();
            this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
          }
        });
      } else {
        this.cancelCropping();
        this.snotify.error('This image cannot be cropped.', '', this.sharedService.getConfig(false));
      }
    } else {
      return false;
    }
  }

  openCropper(isCropForLeadMedia, data) {
    const imageUrl2 = this.isSecondImagePresent();
    if (imageUrl2) {
      this.sharedService.createObjectFromImageUrl(imageUrl2, (data2, reader2) => {
        if (data2 !== false) {
          this.setCroppingData(isCropForLeadMedia, {
            data: data.data,
            url: data.url,
            data2: data2.data,
            url2: data2.url
          });
        } else {
          this.cancelCropping();
          this.snotify.error('Image path does not exist for second image.', '', this.sharedService.getConfig(false));
        }
      });
    } else {
      this.setCroppingData(isCropForLeadMedia, data);
    }
  }
  copyCaption(elementId) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value =this.serveElement(elementId).image.caption;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snotify.info('Caption copied to Clipboard', '', this.sharedService.getConfig(false));
  }

  finishCropping(event) {
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    const id = this.id[0];
    if (this.cropForLeadMedia) {
      //this.setAsLeadMediafn.emit(this.id);
      this.setAsLeadMediafn.emit(id);
    }
    this.cancelCropping();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        this.ampValidationOutput.emit(ampFlag);
        //let leadElement = cloneDeep(this.elements[this.id]);
        let leadElement = cloneDeep(this.elements[id]);
        leadElement.imageAmpValidated = ampFlag;
        leadElement.image.verticalImage = verticalFlag;
        leadElement.image.images = imagemap;
        // this.tempElements.get(this.id).imageAmpValidated = ampFlag;
        // this.tempElements.get(this.id).image.verticalImage = verticalFlag;
        // this.tempElements.get(this.id).image.images = imagemap;
        // this.overrideSave(this.tempElements.get(this.id), leadElement);
        this.tempElements.get(id).imageAmpValidated = ampFlag;
        this.tempElements.get(id).image.verticalImage = verticalFlag;
        this.tempElements.get(id).image.images = imagemap;
        this.overrideSave(this.tempElements.get(id), leadElement);
      } else {
        console.log(data);
      }
    });
  }

  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null,
      blobData: null
    };
    this.cropForLeadMedia = false;
    this.cropCompletedEvent.emit('Cropping completed');
    if(this.id && this.id.length>0)
    {
      this.id.splice(0,1);
    }
    // this.sharedService.overflowauto();
  }

  setCroppingData(isCropForLeadMedia, data) {
    this.cropForLeadMedia = isCropForLeadMedia;
    this.sharedService.overflowhidden();
    this.cropperImageUrl = data;
  }

  isSecondImagePresent() {
    // const elementImageURL2 = this.isMultipleLeadImageAllowed && this.tempElements.get(this.id)['image']['images'].hasOwnProperty('original2')
    //   ? this.tempElements.get(this.id)['image']['images']['original2'] : false;
    const elementImageURL2 = this.isMultipleLeadImageAllowed && this.tempElements.get(this.id[0])['image']['images'].hasOwnProperty('original2')
      ? this.tempElements.get(this.id[0])['image']['images']['original2'] : false;
    const imageUrl2 = elementImageURL2 ?
      (this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL2) : false;
    return imageUrl2;
  }

  deleteElement(elementId) {
    let cardData = this.elements[elementId];
    if (cardData.hasOwnProperty('parentElementId') && (cardData['parentElementId'] !== 0)) {
      this.emitParentImageIdDelete.emit(cardData['parentElementId']);
    } else {
      this.emitParentImageIdDelete.emit(cardData['id']);
    }
    this.deleteCardfn.emit(cardData.id);
  }

  openRelatedStoryForImageTypeModal(ev, id) {
    this.relatedStoryTempList = this.tempElements.get(id).relatedStories ? JSON.parse(JSON.stringify(this.tempElements.get(id).relatedStories)) : [];
    if (ev === 'multiple') {
      this.relatedStoryMultipleSelectFlag = true;
    } else {
      this.relatedStoryMultipleSelectFlag = false;
    }
    this.relatedStoryType = 'gallery';
    this.showRelatedStoryPopup = true;
    if(this.id == null || this.id.length == 0)
    {
      this.id = [];
    }
    this.id.push(id)
    // this.id = id;
    this.sharedService.overflowhidden();
  }

  closeRelatedStoryModal() {
    this.showRelatedStoryPopup = false;
    this.relatedStoryTempList = [];
    this.sharedService.overflowauto();
    this.id.splice(0,1);
    if (this.tempElements.get(this.id) && this.tempElements.get(this.id) !== null && this.tempElements.get(this.id).relatedStories.length === 0) {
      this.deleteElement(this.id);
    }
  }

  receivedRelatedStoryHeadline(ev, elementId, storyId) {
    // const elem = document.getElementById(elementId+'-'+storyId);
    // elem.innerHTML = ev
  }

  getRelatedStoryIds(ev) {
    if ((typeof ev) !== 'number') {
      //this.tempElements.get(this.id)['relatedStories'] = ev;
      this.tempElements.get(this.id[0])['relatedStories'] = ev;
      // this.overrideSave(this.tempElements.get(this.id), null);
      this.closeRelatedStoryModal();
    } else {
      //this.tempElements.get(this.id)['relatedStories'] = [ev];
      this.tempElements.get(this.id[0])['relatedStories'] = [ev];
      // this.changeRelated.emit(this.tempElements.get(this.id).relatedStories);
      // this.overrideSave(this.tempElements.get(this.id), null);
      this.closeRelatedStoryModal();
    }
  }

  getRelatedStoryData(ev) {
    //this.tempElements.get(this.id).relatedStories = [ev.id];
    this.tempElements.get(this.id[0]).relatedStories = [ev.id];
    //this.tempCardData.relatedStoryHeadline=ev.headline
    this.closeRelatedStoryModal();
  }

  overrideSave(cardData, leadElement) {
    if (cardData !== null && cardData.id !== null) {
      if (!cardData.reusable) {
        this.isLocked.set(cardData.id, true);
        cardData['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
        cardData['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
        this.saveCard(cardData.id, leadElement, flag2 => { });
      } else {
        this.lockAcquire(cardData.id, flag => {
          if (flag) {
            this.saveCard(cardData.id, leadElement, flag2 => {
              this.lockRelease(cardData.id, flag3 => {
                if (!flag3) {
                  console.log('lock not released');
                }
              });
            });
          } else {
            console.log('lock not acquired');
          }
        });
      }
    } else {
      console.log('override cancelled');
    }
  }

  lockRelease(card_id, callback) {
    if (this.isLocked.get(card_id)) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            this.isLocked.set(card_id, false);
            callback(data);
          },
          error => {
            callback(false);
          });
    } else {
      callback(true);
    }
  }

  lockAcquire(card_id, callback) {
    if (!this.isLocked.get(card_id) && card_id !== null) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            if (data) {
              this.isLocked.set(card_id, true);
              this.tempElements.get(card_id)['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
              this.tempElements.get(card_id)['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
            }
            callback(data);
          },
          error => {
            callback(false);
          });
    } else {
      callback(true);
    }
  }

  ckchanges(ev, label, model) {
    if (label === 'ready') {
      switch (model) {
        case 'caption':
          ev.editing.view.focus();
          this.captionEditor = ev;
          console.log(this.captionEditor);
          break;
        default: break;
      }
    }
    if (label === 'focus') {
      switch (model) {
        case 'caption':
          this.captionEditor = ev.editor;
          console.log(this.captionEditor);
          this.removePlaceholder(ev.editor);
          break;
        default: break;
      }
    }
    if (label === 'blur') {
      switch (model) {
        case 'caption':
          this.addOrRemovePlaceholder(ev.editor)
          break;
        default: break;
      }
    }
    if (label === 'change') {
    }
  }

  onChange({ editor }: ChangeEvent,model,elementId) {
    switch(model) {
      case 'caption': this.tempElements.get(elementId).image.caption = editor.getData();
      this.checkingHyperlinkValid(editor,model,this.tempElements.get(elementId).image.caption);
      break;
      default:
      break;
    }
  }

  checkingHyperlinkValid(editor,type,data) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl = this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
                }
              }, 1000); 
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
              }
            }, 1000); 
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })
          
          }
          }
      }
    }
     else {
      return true;
    }
  }

  checkUrlValidate(url,data,type,editor) {
    var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
    let allLink =  this.sharedService.findInvalidLinkWord(editor);
    let matchLinkObj = allLink.filter(e =>e.href===url)
    if(urlValid.test(url) === false) {
       this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     } else if(!url.startsWith('https')) {
       this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);    
     }
     return urlValid.test(url) && url.startsWith('https') ;
  }

  getremoveInvalidLink(cardData,word,type,editor){
    let paraBody=cardData;
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
        }
      }
  }

  editAmazonData(elementId) {
    this.tempElements.get(elementId).amazonCheckedItem = false;
  }

  checkItemsAmazonMeta(id) {
    this.amazonAds = [];
    this.amazonAds.push({ key: this.tempElements.get(id).amazonAds[0].key, value: this.tempElements.get(id).amazonAds[0].value ,isPresent:true});
    this.restService.http_post(this.config.get('product').baseUrl + '/cms/affiliate/checkItems/',
    this.amazonAds, result => {
     if(result.length>0){
      this.tempElements.get(id).amazonAds=result;
      this.tempElements.get(id).amazonCheckedItem = true;
     }})
  }

  setThisAsLeadMedia(id) {
    let cardData = this.tempElements.get(id);
    if (id === this.leadMediaId) {
      this.setAsLeadMediafn.emit(id);
    } else {
      const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
        this.sharedService.getImageOnPriority(this.tempElements.get(id)['image']['images'], 'original');
      this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
        if (data !== false) {
          if (cardData.hasOwnProperty('imageAmpValidated') && cardData.imageAmpValidated) {
            
            //this.id = id;
            if(this.id == null || this.id.length == 0)
            {
              this.id = [];
            }
            this.id.push(id);
            this.storyData.type==='infographic' ? this.showCropper = false : this.showCropper = true;
            if (this.storyData.type==='infographic') {
              this.setAsLeadMediafn.emit(id);
            }
            this.openCropper(true, data);
          } else {
            this.sharedService.checkImageForAMP(reader, flag => {
              if (flag) {
                
                //this.id = id;
                if(this.id == null || this.id.length == 0)
                {
                  this.id = [];
                }
                this.id.push(id);
                this.storyData.type==='infographic' ? this.showCropper = false : this.showCropper = true;
                if (this.storyData.type==='infographic') {
                  this.setAsLeadMediafn.emit(id);
                }
                this.openCropper(true, data);
              } else {
                this.sharedService.showAMPConfirmPopup(() => { // yes
                  
                  //this.id = id;
                  if(this.id == null || this.id.length == 0)
                  {
                    this.id = [];
                  }
                  this.id.push(id);
                  this.storyData.type==='infographic' ? this.showCropper = false : this.showCropper = true;
                  if (this.storyData.type==='infographic') {
                    this.setAsLeadMediafn.emit(id);
                  }
                  this.openCropper(true, data);
                },
                  () => { // no
                    this.cancelCropping();
                  }
                );
              }
            });
          }
        } else {
          this.cancelCropping();
          this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
        }
      });
    }
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    } else {
      return text;
    }
  }

  setTags(id, event) {
    this.tempElements.get(id).metadata.tags = event;
  }

  setChangesMeta(id) {
    if (isEqual(this.tempElements.get(id), this.elements[id])) {
      this.tempElements.set(id, cloneDeep(this.elements[id]));
      this.editCardFlag.set(id, false);
    } else {
      this.tempElements.get(id).image.title = this.tempElements.get(id).title;
      this.tempElements.get(id).image.caption = (this.tempElements.get(id).image.caption && this.tempElements.get(id).image.caption.trim() !== '')
        ? (this.sharedService.isdomainConfig('story', 'captionStripTagDisabled') ? this.tempElements.get(id).image.caption : this.htmlToPlaintext(this.tempElements.get(id).image.caption)) : '';
      this.overrideSave(this.tempElements.get(id), null);
    }
  }

  discardMetaChanges(id) {
    this.tempElements.set(id, cloneDeep(this.elements[id]));
    //this.editCardFlag.set(id,false);
  }

  saveCard(id, leadElement, callback) {
    let cardData = this.tempElements.get(id);
    if (leadElement) {
      cardData = leadElement;
    }
    if (this.isLocked.get(id)) {
      const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
        JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
        : null;
      cardData['lockedByUserId'] = token.email;
      cardData['lockedByUserName'] = token.name;
      this.storyData.type==='infographic'?cardData.image['infographicImage'] = true : cardData.image['infographicImage'] = false
      cardData.lastModifiedBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      this.restService.http_put(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
        + '/' + String(cardData.id) + '?autoSave=true',
        this.sharedService.checkhrefandreplace(cardData),
        result => {
          if (!result || result.hasOwnProperty('error')) {
            console.log('lock error');
            this.isLocked.set(id, false);
            this.overrideSave(cardData, leadElement);
          }
          if (result) {
            this.updateCardDatafn.emit(result);
            this.resgisterDataChangeToParent(result);
            if (leadElement) {
              let result2 = cloneDeep(result);
              result2.image.caption = this.tempElements.get(id).image.caption;
              result2.title = this.tempElements.get(id).title;
              result2.image.imageUrl = this.tempElements.get(id).image.imageUrl;
              result2.image.name = this.tempElements.get(id).image.name;
              result2.image.imageCredit = this.tempElements.get(id).image.imageCredit;
              result2.metadata.tags = this.tempElements.get(id).metadata.tags;
              result2.relatedStories = this.tempElements.get(id).relatedStories;
              this.tempElements.set(id, result2);
            } else {
              this.editCardFlag.set(id, false);
              this.tempElements.set(id, result);
            }

            if (result.metadata && result.metadata.wordCount) {
              this.calculateElementWordCount({
                id: result.id,
                count: result.metadata.wordCount
              });
              // this.cardData.metadata.wordCount = result.metadata.wordCount;
            }
          }
          callback(result);

        });
    } else {
      this.overrideSave(cardData, leadElement);
      callback(false);
    }
  }

  resgisterDataChangeToParent(data) {
    if (data !== null && data.id !== null) {
      this.updateContentOnParent.emit(data);
    }
  }

  calculateElementWordCount(ev) {
    this.sendWordCountToStory.emit(ev);
  }

  captionKeyDownEventCk($event, elementId) {
    const key = $event.keyCode || $event.charCode;
    const selection = this.captionEditor.model.document.selection;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 52:
        if (ctrl_shift) {
          this.captionEditor.model.change(writer => {
            this.captionEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 72:
        if (this.sharedService.isdomainConfig('story', 'captionStripTagDisabled') && ctrl_shift) {
          console.log('hyperlink');
          const b : any = document.getElementById("captionEl" + elementId).getElementsByClassName('ck-toolbar__items');
          const a = b[0].children;
          $event.preventDefault();
          if (a.length > 2) {
            a[2].click()
          }
          $event.stopPropagation();
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.captionEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.captionEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.captionEditor.setData(totalPara);
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }

  stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  addOrRemovePlaceholder(editorInstance) {
    const hasData = editorInstance.getData();
    if (hasData) {
      this.removePlaceholder(editorInstance);
    } else {
      this.addPlaceholder(editorInstance);
    }
  }

  addPlaceholder(editorInstance) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.addClass(editableElement.children[0], 'ck-placeholder');
    this.renderer.setAttribute(editableElement.children[0], 'id', 'addCaptionText');
    this.renderer.setAttribute(editableElement.children[0], 'data-placeholder', 'Add caption here');
  }

  removePlaceholder(editorInstance) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.removeAttribute(editableElement.children[0], 'data-placeholder');
    this.renderer.removeClass(editableElement.children[0], 'ck-placeholder');
  }
}